// 首页
<template>
  <div class="setup">
    <van-nav-bar
      :title="$t('menu.setup')"
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
      z-index="5"
    />
    <section class="container">
      <div class="card">
        <div class="card-item">
          <div>
            <div class="title">Auto lock setting</div>
            <div class="desc">
              After
              <span class="flex align-center">
                <van-icon
                  :name="require('@/assets/images/icon/edit.png')"
                ></van-icon>
                <van-field
                  type="digit"
                  v-model="minutes_Lock"
                  input-align="center"
                  @change="lockChange"
                />
              </span>
              minutes of inactivity to lock.
            </div>
            <div class="title">Unlock operation</div>
            <div class="desc">Continuously vape 3 times to unlock.</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-item">
          <div class="title">ZEN mode setting</div>
          <div class="desc">
            The device will lock for
            <span class="flex align-center">
              <van-icon
                :name="require('@/assets/images/icon/edit.png')"
              ></van-icon>
              <van-field
                type="digit"
                v-model="minutes_Zen"
                input-align="center"
                @change="zenChange"
              />
            </span>
            minutes.
          </div>
          <div class="desc">
            After the time is up, the device will auto-unlock.
          </div>
        </div>
      </div>
    </section>
    <tab-bar />
  </div>
</template>

<script>
import TabBar from "@/components/tab-bar";
export default {
  name: "Home",
  components: {
    TabBar,
  },
  data() {
    return {
      deviceInfo: {}, // 设备信息
      minutes_Lock: 3,
      minutes_Zen: 3,
    };
  },
  computed: {
    token() {
      return this.$store.state.user.token;
    },
  },
  created() {
    this.deviceInfo = this.$route.params.deviceInfo;
    this.getConfig();
  },
  methods: {
    /** 当前设备已连接 */
    curDeviceIsConnected(doNotShowToast) {
      const result = this.$store.state.app.idOfConnectedDevice === this.deviceInfo.id;
      if (!result && !doNotShowToast) this.$toast("Please connect device.");
      return result;
    },
    /** 格式化输入内容(锁) */
    formatter_Lock(newVal) {
      const upperLimit = 15;
      const lowerLimit = 1;
      if (newVal > upperLimit) this.$toast("Maximum 15 minutes.");
      return newVal > upperLimit
        ? upperLimit
        : newVal < lowerLimit
        ? lowerLimit
        : newVal;
    },
    lockChange() {
      if (!this.curDeviceIsConnected(false)) return;
      this.minutes_Lock = this.formatter_Lock(parseInt(this.minutes_Lock));

      /** 通知宿主更改锁计时器 */
      window.webkit.messageHandlers.changeTimerOfLock.postMessage(
        this.minutes_Lock
      );
      this.saveConfig();
    },
    /** 格式化输入内容(ZEN) */
    formatter_Zen(newVal) {
      const upperLimit = 7200;
      const lowerLimit = 1;
      if (newVal > upperLimit) this.$toast("Maximum 7200 minutes.");
      return newVal > upperLimit
        ? upperLimit
        : newVal < lowerLimit
        ? lowerLimit
        : newVal;
    },
    zenChange() {
      if (!this.curDeviceIsConnected(false)) return;
      this.minutes_Zen = this.formatter_Zen(parseInt(this.minutes_Zen));

      /** 通知宿主更改禅计时器 */
      window.webkit.messageHandlers.changeTimerOfZen.postMessage(
        this.minutes_Zen
      );
      this.saveConfig();
    },
    /** 获取存储键 */
    getLocalStorageKey() {
      return `LockTimeConfig_${this.deviceInfo.id}`
    },
    /** 获取配置 */
    getConfig() {
      const data_JSONString = localStorage.getItem(this.getLocalStorageKey());
      if (!data_JSONString) return;
      const data_Object = JSON.parse(data_JSONString);
      this.minutes_Lock = data_Object.minutes_Lock;
      this.minutes_Zen = data_Object.minutes_Zen;
    },
    /** 保存配置 */
    saveConfig() {
      const data = {
        minutes_Lock: this.minutes_Lock,
        minutes_Zen: this.minutes_Zen
      };
      localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(data));
    },
  },
};
</script>

<style lang="less">
.setup {
  .container {
    overflow: hidden;
    padding: 24px 0;
  }
  .van-pull-refresh {
    overflow: inherit;
  }
  .card {
    padding: 0 24px 24px;
    .card-item {
      background: #fff;
      padding: 25px 35px;
      border-radius: 15px;
      box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
      font-size: 28px;
      .title {
        padding: 0;
        font-weight: bold;
        line-height: 2.5;
      }
      .desc {
        line-height: 2.5;
        font-size: 26px;
        span {
          display: inline-flex;
          font-weight: bold;
          margin: 0 6px;
          padding: 4px 26px;
          border: 2px solid #b6b6b6;
          width: 98px;
          border-radius: 15px;
          .van-cell {
            padding: 0;
            display: inline-block;
          }
          .van-field__control {
            color: #5de7bf;
          }
        }
      }
    }
  }
}
</style>
